export function CartLineItemSkeleton({ index }) {
  return (
    <article
      key={index}
      className="cart-item checkout-summary checkout-summary--section skeleton"
      aria-hidden="true"
    >
      <div className="skeleton-img" />
      <div className="skeleton-body">
        <div className="skeleton-line w-75" />
        <div className="skeleton-line w-50" />
        <div className="skeleton-line w-50" />
        <div className="skeleton-qty-row">
          <div className="skeleton-pill" />
          <div className="skeleton-pill" />
        </div>
      </div>
    </article>
  );
}

export function CartSummarySkeleton() {
  return (
    <div className="subtotal-skeleton w-100" aria-hidden="true">
      <div className="skeleton-line w-50 mb-3" />
      <div className="skeleton-line w-75 mb-2" />
      <div className="skeleton-line w-50 mb-4" />
      <div
        className="skeleton-block"
        style={{ height: '3rem', marginBottom: '0.85rem' }}
      />
      <div className="skeleton-line mb-2" />
      <div className="skeleton-line mb-2" />
      <div className="skeleton-line w-75 mb-4" />
      <div className="skeleton-block" style={{ height: '2.75rem' }} />
    </div>
  );
}
